import { t } from 'i18next';

import { Button } from '../../../../components/ui/button';
import { Input } from '../../../../components/ui/input';

type Props = {
  /** Переведённый текст ошибки геокодера; пусто — просто долго ждём. */
  errorMessage: string;
  isRetrying: boolean;
  value: string;
  onChange: (value: string) => void;
  onRetry: () => void;
};

/**
 * Геокодер не ответил или отвечает слишком долго: даём повторить запрос и
 * ввести адрес руками, чтобы сохранение не упиралось в третью сторону.
 */
export const AddressTitleFallback = ({
  errorMessage,
  isRetrying,
  value,
  onChange,
  onRetry,
}: Props) => (
  <div className="flex flex-col space-y-2 mb-[16px]">
    <p className="text-caption-sm-medium text-text-tertiary px-1">
      {errorMessage || t('address-lookup-slow')}
    </p>
    <div className="flex flex-row space-x-2">
      <Input
        className="flex-1 rounded-xl h-12 border-none shadow-none bg-fill-base"
        placeholder={t('address-enter-manually')}
        value={value}
        onChange={event => onChange(event.target.value)}
      />
      <Button
        type="button"
        className="h-12 px-4 bg-button-secondary text-text-primary rounded-xl shadow-none"
        onClick={onRetry}
        disabled={isRetrying}
      >
        <p className="text-body-base-semibold">{t('retry')}</p>
      </Button>
    </div>
  </div>
);
